import { prefersReducedMotion } from '../../utils';

class Video {
	constructor(element, toggleButton) {
		this.el = element;
		this.toggleButton = toggleButton;
		this.init = this.init.bind(this);
		this.togglePlay = this.togglePlay.bind(this);
		this.isMobileDevice = navigator.userAgent.match(/Mobi/);
	}

	init() {
		// if not mobile device, or user turned enables reduced motion
		// it should play be default
		if (!prefersReducedMotion || !this.isMobileDevice) {
			this.el.play();
		}
	}

	togglePlay() {
		if (this.el.paused) {
			this.el.play();
		} else {
			this.el.pause();
		}
	}
}

export default Video;
